
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LogoContainer',

  props: {
    logo: {
      type: String,
      required: true
    },
    outerDimensions: {
      type: String,
      default: 'h-10 w-10'
    },
    innerDimensions: {
      type: String,
      default: 'h-6 w-6'
    },
    name: {
      type: String,
      default: ''
    }
  }
})
